// extracted by mini-css-extract-plugin
module.exports = {"statsCardWrapper":"styles_statsCardWrapper__Pj2gn","pageContentWrapper":"styles_pageContentWrapper__38mW2"};